import React from 'react';
import './style.scss';

class Radio extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);        
        this.onLabelClick = this.onLabelClick.bind(this);        
        this.onLabelClickKeyup = this.onLabelClickKeyup.bind(this);        
    }

    componentDidMount() {
    }

    onChange(e) {
        const trg = e.target;
        this.props.change(trg.value, this.props.name, this.props.id);
    }

    onLabelClick() {
        this.props.change(this.props.value, this.props.name, this.props.id);
    }

    onLabelClickKeyup(e) {
        if (e.keyCode === 13 || e.keyCode === 32) this.onLabelClick();
    }

    render() {
        return (
            <div className="custom-radio">
                <input
                    type="radio"
                    value={this.props.value}
                    id={this.props.id}
                    name={this.props.name}
                    onChange={this.onChange}
                    checked={this.props.isSelected}
                />
                <label onClick={this.onLabelClick} className="custom-radio-box mr-2" aria-label={this.props.label}>
                    <span className="visually-hidden">{this.props.label}</span>
                    {/* <i className="fa fa-circle"></i> */}
                </label>
                <label 
                    className="custom-radio-label" 
                    tabIndex="0" 
                    for={this.props.id} 
                    onClick={this.onLabelClick}
                    onKeyUp={this.onLabelClickKeyup}
                >{this.props.label}</label>
            </div>
        )
    }
    
}

export default Radio;


// WEBPACK FOOTER //
// ./src/components/HTMLelements/Radio/Radio.js